import { AxiosConfigSingleton } from "./axios-config-singleton";

const axiosInstance = AxiosConfigSingleton.getClient();

export default axiosInstance;
